<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 class="display-1 mb-4">{{ title }}</h2>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-end>
                <v-btn @click="getReferralReport" color="primary"> Get {{ title }} </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    components: {},
    computed: {},
    created() {},
    props: ["title"],
    watch: {},
    data: function () {
        return {};
    },
    computed: {},
    methods: {
        getReferralReport: function () {
            this.$router.push({
                name: "referralReport",
            });
        },

        dateFormatted: function (date) {
            return date ? this.$moment(date).format("dddd, MMMM D") : "";
        },
    },
};
</script>
